import PropTypes from "prop-types";

const CustomPropTypes = {
  keyedElementList: PropTypes.arrayOf(
    PropTypes.shape({
      element: PropTypes.element.isRequired,
      key: PropTypes.string.isRequired,
    })
  ),
};

export default CustomPropTypes;



// WEBPACK FOOTER //
// ./src/CustomPropTypes.js